export default "__VITE_ASSET__DggmmrMG__"